import styles from "./expenseCategoryCard.module.css";
import { Dropdown } from "react-bootstrap";
import { Edit, MoreVertical, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { useAuth0 } from "@auth0/auth0-react";

const ExpenseCategoryCard = ({ item, setDeleteModalOpen, setSelectecId, setEditModalOpen, setEditUserData }) => {
  const { user, isAuthenticated } = useAuth0();

  return (<Link className={`${styles.ProspectCard}`} onClick={(e) => {
    if (item?.is_primary) return;
    if (isAuthenticated && user["https://propertydek.com/permissions"].indexOf("expense-category:update") > -1) {
      setEditModalOpen(true);
      setEditUserData(item);
    } else {
      return false;
    }
  }}
  >
    <div className={`${styles.ProspectCardUnder}`}>
      <div className={`${styles.ProspectCardHeadSection}`}>
        {!item?.is_primary && isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("expense-category:update") > -1 || user["https://propertydek.com/permissions"].indexOf("expense-category:delete") > -1) && (<Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
          <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
            <MoreVertical />
          </Dropdown.Toggle>

          <Dropdown.Menu className={`${styles.ActionsBUList}`}>
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("expense-category:update") && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setEditModalOpen(true); setEditUserData(item); }}>
              <Edit /> Edit
            </Dropdown.Item>}
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("expense-category:delete") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalOpen(true); setSelectecId(item.id); }}>
              <Trash2 /> Delete
            </Dropdown.Item>}
          </Dropdown.Menu>
        </Dropdown>)}

        <div className={`${styles.ProsIMGSec}`}>
          <img src="/static/img/category-income.svg" alt="" />
        </div>
        <div className={`${styles.HeadConSec}`}>
          <p className={`${styles.ProsUserName}`}>
            <span className={`${styles.UserName}`}>{item?.title}</span>
          </p>
        </div>
      </div>
      <div className={`${styles.ProspectCardFootSec}`}>
        <p className={`${styles.LeaseConDate}`}>{dayjs(item?.created_at).fromNow()}</p>
        <span style={{ backgroundColor: item?.color }} className={`${styles.PublishBadge}`}>{item?.color}</span>
      </div>
    </div>
  </Link>);
};

export default ExpenseCategoryCard;